import { takeLatest, put, call } from 'redux-saga/effects';

import { listNaturezaOperacaoCadastro } from '../service';
import {
  TABLE_NATUREZA_OPERACAO_CADASTRO,
  TABLE_NATUREZA_OPERACAO_CADASTRO_PENDING,
  TABLE_NATUREZA_OPERACAO_CADASTRO_SUCCESS,
  TABLE_NATUREZA_OPERACAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListNaturezaOperacaoCadastro(action) {
  yield put({ type: TABLE_NATUREZA_OPERACAO_CADASTRO_PENDING })

  try {
    const table = yield call(listNaturezaOperacaoCadastro, action.args)
    yield put({ type: TABLE_NATUREZA_OPERACAO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_NATUREZA_OPERACAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListNaturezaOperacaoCadastro() {
  yield takeLatest(TABLE_NATUREZA_OPERACAO_CADASTRO, sagaListNaturezaOperacaoCadastro)
}